import { render, staticRenderFns } from "./EstruturaUsuarioTabela.vue?vue&type=template&id=107ee49c&lang=html"
import script from "./EstruturaUsuarioTabela.vue?vue&type=script&lang=js"
export * from "./EstruturaUsuarioTabela.vue?vue&type=script&lang=js"
import style0 from "./EstruturaUsuarioTabela.vue?vue&type=style&index=0&id=107ee49c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports